import React, { useState } from 'react'
import { Header, Form, Button, Image } from 'semantic-ui-react'
import { InputField } from '..'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import logo from '../../images/logo.svg'
import style from '../../styles'

const VerifyTokenCard = (props) => {
  const { width } = useWindowDimensions();
  const [ data, setData ] = useState({mail: null, token: null})

  const handleOnChange = (e) => {
    const { id, value } = e.target
    setData(prevData => ({
        ...prevData,
        [id]: value
    }))
  }

  const handleOnSubmit = () => {
    if(data.mail && data.token)
      props.onButtonClick(data)
  }

  return(
    <div style={width > 768 ? style.loginWrapper : style.loginWrapperMobile}>
      <div style={width > 768 ? style.login : style.loginMobile}>
        <div style={width > 768 ? style.loginHeader : style.loginHeaderMobile}>
          <Image src={logo} style={style.logo} />
        </div>
        <Header style={{fontFamily: 'Futura', fontSize: '3rem', fontWeight: '300'}} as='h1'>{props.headline}</Header>
        <Header style={{fontFamily: 'Futura', fontSize: '2rem', fontWeight: '300'}} as='h3'>{props.subline}</Header>
        <div style={{ width: '80%', margin: 'auto', display: 'inline-block', marginBottom: 40}}>
          <Form loading={props.loading}>
            <Form.Group>
              <InputField 
                handleOnChange={handleOnChange}
                value={data.mail}
                id="mail"
                type="mail"
                label={props.labelMail}
                required
              />
            </Form.Group>
            <Form.Group>
              <InputField 
                handleOnChange={handleOnChange}
                value={data.token}
                id="token"
                type="password"
                label={props.labelResetCode}
                required
              />
            </Form.Group>
          </Form>
          <div style={{textAlign: 'left'}}>
            <Button size='large' secondary onClick={handleOnSubmit} >{props.buttonText}</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyTokenCard